import React, { forwardRef } from 'react';
import { Checkbox as CheckboxBase, CheckboxProps } from '@mui/material';
import { ReactComponent as CheckboxCheckedIcon } from '../../assets/checkbox-checked.svg';
import { ReactComponent as CheckboxDashedIcon } from '../../assets/checkbox-dash.svg';
import { ReactComponent as CheckboxIcon } from '../../assets/checkbox.svg';

type Props = CheckboxProps & {
  $noPadding?: boolean;
};

const Checkbox = forwardRef(({ $noPadding, ...props }: Props, ref: any) => (
  <CheckboxBase
    ref={ref}
    {...props}
    sx={{
      '&:hover': { bgcolor: 'transparent' },
      '&.MuiButtonBase-root': {
        padding: $noPadding ? '0 !important' : undefined,
      },
      ...props.sx,
    }}
    icon={<CheckboxIcon />}
    checkedIcon={<CheckboxCheckedIcon />}
    indeterminateIcon={<CheckboxDashedIcon />}
  />
));

export default Checkbox;
